import { render, staticRenderFns } from "./ShippingFee.vue?vue&type=template&id=02988993&"
import script from "./ShippingFee.vue?vue&type=script&lang=js&"
export * from "./ShippingFee.vue?vue&type=script&lang=js&"
import style0 from "./ShippingFee.vue?vue&type=style&index=0&id=02988993&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports